//----------------------------
// create changed rune entry
//----------------------------
export default function createChangedRuneEntry({
  name = '', // rune name
  action = '', // 'ADD', 'UPDATE', 'DELETE'
  id = null, // for character-rune updates/deletes (character-rune id) / will be temp-id for new rune (tracking only)
  payload = {},
} = {}) {
  //--------------------------------------------------------------------------
  // basic validation - name and action are required for a valid change entry
  //--------------------------------------------------------------------------
  if (!name || !action) {
    throw new Error('Invalid input: name and action are required')
  }
  //--------------------------------------
  // extract payload fields with defaults
  //--------------------------------------
  const {
    character = null, // for new character_rune (character id)
    rune = null, // for new character_rune (static rune id)
    strength = 0,
    pwr_storage = 0,
    starter = false,
    integrated = false,
    active = false,
    character_item = null,
    notes = '',
  } = payload || {}
  //---------------------------------------------
  // resolve ids (explicit null if not provided)
  //---------------------------------------------
  const resolvedRuneId = rune ?? null
  const resolvedCharacterId = character ?? null
  //--------------------------------------------------------------------------
  // build output object progressively with clear intent for each action type
  //--------------------------------------------------------------------------
  const out = {
    name,
    action,
  }
  //---------------------------------------------------------------------
  // for ADD & UPDATE: include payload object describing editable fields
  //---------------------------------------------------------------------
  if (action === 'ADD' || action === 'UPDATE') {
    const outPayload = {
      strength,
      pwr_storage,
      starter,
      integrated,
      active,
      character_item,
      notes,
    }
    //--------------------------------------------------------------------
    // for ADD: also include static rune id & character id inside payload
    //--------------------------------------------------------------------
    if (action === 'ADD') {
      outPayload.rune = resolvedRuneId
      outPayload.character = resolvedCharacterId
    }
    //-------------------------------------
    // assign constructed payload to output
    //--------------------------------------
    out.payload = outPayload
  }
  //-----------------------------------------------------------------------------------
  // UPDATE & DELETE: id = character-rune id
  // ADD: id = temp id for tracking (actual character-id + static rune-id provided inside payload for server-side creation)
  //-----------------------------------------------------------------------------------
  if (id != null) {
    out.id = id
  }
  //----------------
  // return results
  //----------------
  return out
}
